import { get, set, reject } from 'lodash/fp';
import getItemAvailabilityUniqId from '../getItemAvailabilityUniqId';

export default routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    deleting: true,
    deleted: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) => {
    const itemId = get('item.id', response);
    const availability = reject(
      each =>
        getItemAvailabilityUniqId(each) === getItemAvailabilityUniqId(response),
      get(`byItemId.${itemId}`, state)
    );

    return set(`byItemId.${itemId}`, availability, state);
  },
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    deleting: false,
    deleted: true
  })
});
